import React, { useEffect, useState } from 'react';
import { fetchStatistics } from '../../services/api';
import { Statistics } from '../../types/types';
import { formatNumber } from '../../utils/general';

export default function StatisticsSection() {
  const [statistics, setStatistics] = useState<Statistics[]>([]);

  useEffect(() => {
    fetchStatistics()
      .then((data) => setStatistics(data))
      .catch((err) => console.error('Error while retrieving statistics:', err));
  }, []);

  return (
    <section className="py-2 bg-white text-black dark:bg-neutral-900 dark:text-white">
      <h2 className="text-4xl text-center font-extrabold tracking-tighttext-gray-800 dark:text-gray-100 mb-6">
        Statistics
      </h2>
      <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto px-6">
        {statistics.map((stat, idx) => (
          <div
            key={idx}
            className="flex-1 min-w-[150px] max-w-[200px] bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition duration-300 ease-in-out text-center"
          >
            {stat.url ? (
              <a href={stat.url} target="_blank" rel="noopener noreferrer">
                <p className="text-4xl font-bold text-gray-900 dark:text-gray-200">
                  {formatNumber(stat.stats)}
                </p>
              </a>
            ) : (
              <p className="text-4xl font-bold text-gray-900 dark:text-gray-200">
                {formatNumber(stat.stats)}
              </p>
            )}
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
